import { isProduction } from '@honeybook/utils-web';
import { safeJsonClone } from '@honeybook/utils';
export function logToConsole(type, message, context) {
    const date = new Date();
    const timeString = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}.${date.getMilliseconds()}`;
    const levelString = type.toUpperCase().padEnd(5, ' ');
    let logMetadata;
    try {
        // To have a structured, expandable, object in dev tools
        logMetadata = safeJsonClone(context);
    }
    catch {
        logMetadata = String(context);
    }
    console.debug(`${timeString} | ${levelString} | ${message}`, logMetadata);
}
export function logToDataDog({ type, message, context = {}, sampleRate, enrichContext }) {
    // Added to ease investigation in staging and e2e envs, where we don't have DD
    if (!isProduction()) {
        logToConsole(type, message, context);
    }
    const datadog = window?.DD_LOGS;
    if (!datadog || !datadog.logger) {
        return;
    }
    const enrichedContext = enrichContext ? enrichContext(context) : context;
    if (!sampleRate) {
        datadog.logger[type](message, enrichedContext);
    }
    else if (Math.random() <= sampleRate) {
        datadog.logger[type](message, enrichedContext);
    }
}
export function logDebug(message, context = {}, enrichContext) {
    logToDataDog({ type: 'debug', message, context, enrichContext });
}
export function logInfo(message, context = {}, sampleRate, enrichContext) {
    logToDataDog({
        type: 'info',
        message,
        context,
        sampleRate,
        enrichContext
    });
}
export function logWarn(message, context = {}, sampleRate, enrichContext) {
    logToDataDog({
        type: 'warn',
        message,
        context,
        sampleRate,
        enrichContext
    });
}
export function logError(message, context = {}, sampleRate, enrichContext) {
    logToDataDog({
        type: 'error',
        message,
        context,
        sampleRate,
        enrichContext
    });
}
//# sourceMappingURL=logger.utils.js.map